<template>
  <div>
    <div class="i8-loader" :class="{ 'i8-page-loader': isPageLoader }">
      <div class="i8-loader-spinner" :class="sizeClass">
        <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" :stroke="color" :stroke-width="strokeWidth" :stroke-linecap="strokeLinecap" stroke-miterlimit="10"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
const name = 'loader';
export default {
    name,
    componentName: name,

    props: {
        color: { type: String, default: '#404040' },
        strokeWidth: { type: String, default: '3' },
        strokeLinecap: { type: String, default: 'square' },
        size: { type: String, default: 'medium' },
    },

    data() {
        return {};
    },

    computed: {
        sizeClass() {
            let c = {};
            c[this.size] = true;
            return c;
        },

        isPageLoader() {
            return this.size === 'page';
        },
    },

    methods: {},
};
</script>



// WEBPACK FOOTER //
// shared/components/Loader.vue